export const ApiPaths = {
  kdesu: {
    osmImports: {
      prefix: "/kdesu/osm-imports",
      list: "/",
      listLatest: "/latest",
      create: "/",
      download: "/:uuid/download",
      importRestaurants: "/:uuid/import-restaurants",
      generateTiles: "/:uuid/generate-tiles",
      activateImport: "/:uuid/activate",
    },
    countries: {
      prefix: "/kdesu/countries",
      list: "/",
      importBoundary: "/:countryCode/import-boundary",
    },
    restaurants: {
      prefix: "/kdesu/restaurants",
      list: "/",
      detail: "/detail/:uuid",
      activeImports: "/active-imports",
    },
    tiles: {
      prefix: "/kdesu/tiles",
      manifest: "/manifest",
    },
  },
  chlast: {
    profile: {
      prefix: "/chlast/profile",
      me: "/me",
    },
  },
  beerrally: {
    races: {
      prefix: "/beerrally/races",
      list: "/",
      detail: "/:domain",
      schedule: "/:domain/schedule",
      map: "/:domain/map",
      registrations: "/:domain/registrations",
      registrationMine: "/:domain/registrations/me",
      videos: "/:domain/videos",
    },
    profile: {
      prefix: "/beerrally/profile",
      me: "/me",
    },
  },
  kukana: {
    databases: {
      prefix: "/kukana/databases",
      list: "/",
      migrate: "/:dbName/migrate",
    },
    logs: {
      prefix: "/kukana/logs",
      list: "/",
      deleteAll: "/",
    },
    races: {
      prefix: "/kukana/beer-rally",
      list: "/",
      create: "/",
      update: "/:raceUuid",
      scheduleExport: "/:raceUuid/schedule/export",
      scheduleImport: "/:raceUuid/schedule/import",
      scheduleRevisions: "/:raceUuid/schedule/revisions",
      scheduleRevisionDownload: "/:raceUuid/schedule/revisions/:revisionNumber",
    },
    users: {
      prefix: "/kukana/users",
      list: "/",
      create: "/",
      update: "/:userUuid",
    },
  },
  auth: {
    prefix: "/auth",
    login: "/login",
    refresh: "/refresh",
    logout: "/logout",
    user: "/user",
  },
  apps: {
    prefix: "/apps",
    list: "/",
  },
  operations: {
    prefix: "/operations",
    list: "/",
    perApp: "/per-app",
  },
} as const;
